import type { ComponentChildren } from "preact";

type ContentCardProps = {
  children: ComponentChildren;
  /** Add negative margin to overlap into the header above */
  overlap?: boolean;
  /** Additional CSS classes */
  class?: string;
};

/**
 * Main content card that can overlap into the branded header.
 * Creates a polished, elevated appearance for page content.
 */
export function ContentCard({
  children,
  overlap = true,
  class: className = "",
}: ContentCardProps) {
  return (
    <div
      class={`
        bg-surface
        rounded-xl
        shadow-sm
        border border-border
        ${overlap ? "-mt-12" : ""}
        ${className}
      `}
    >
      {children}
    </div>
  );
}

/**
 * Padding wrapper for content inside a ContentCard.
 * Use this for consistent spacing within cards.
 */
export function ContentCardBody({
  children,
  class: className = "",
}: {
  children: ComponentChildren;
  class?: string;
}) {
  return <div class={`p-6 lg:p-8 ${className}`}>{children}</div>;
}

/**
 * Section divider within a ContentCard.
 */
export function ContentCardDivider() {
  return <hr class="border-border" />;
}
